import { GameObject } from './gameobject';

export class ItemObject extends GameObject {
    item: any;
    name: string;

    constructor(world: any) {
        super('item', world);
      this.item = null;
    }

    setItem(item: any) {
      let modelIdx;
      if (item.itemType === ITEMTYPE.MONEY) {
        modelIdx = 0;
        this.name = item.money + ' Zulie';
      } else {
        const itemData = GDM.getNow('item_data');
        const itemRow = itemData.getData(item.itemType, item.itemNo);
        modelIdx = parseInt(itemRow[10]);
        this.name = itemData.getName(item.itemType, item.itemNo);
      }
      this.item = item;
      this.pawn.setModel(modelIdx);
    }

}

/**
 * @constructor
 */



